import { GETREQUESTOPTIONS, instance } from '../apiService';

export type PermissionTemplateMode = 'default' | 'custom' | 'unconfigured';
export type TemplateAlertType = 'template_updated' | null;

export interface PermissionTemplate {
    actor_id: string;
    actorRole?: string;
    actorDescription?: string;
    actorScope?: string;
    alternativeNames?: Record<string, string>;
    alternativeDescriptions?: Record<string, string>;
    globalPermissions: string[];
    deptPermissions: string[];
    hasOverride: boolean;
    mode: PermissionTemplateMode;
    userCount: number;
    hasUnacknowledgedChanges: boolean;
    alertType: TemplateAlertType;
}

export const getDeptPermissionTemplates = async (
    departmentId?: string
): Promise<PermissionTemplate[]> => {
    const url = departmentId
        ? `/api/department/admin/${departmentId}/permission-templates`
        : '/api/department/permission-templates';
    const res = await instance.get(url, GETREQUESTOPTIONS());
    return res.data;
};

export const upsertDeptPermissionTemplate = async (
    actorId: string,
    deptPermissions: string[],
    mode: 'default' | 'custom',
    departmentId?: string
): Promise<{ affectedUserCount: number }> => {
    const url = departmentId
        ? `/api/department/admin/${departmentId}/permission-templates`
        : '/api/department/permission-templates';
    const res = await instance.put(
        url,
        { actorId, deptPermissions, mode },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const acknowledgeTemplateChanges = async (
    actorId: string,
    departmentId?: string
): Promise<void> => {
    const url = departmentId
        ? `/api/department/admin/${departmentId}/acknowledge-template-changes`
        : '/api/department/acknowledge-template-changes';
    await instance.post(url, { actorId }, GETREQUESTOPTIONS());
};
